/*******************************************************************************
 * Copyright (c) 2023 GetChkd
 *
 * All rights reserved.
 *
 * Contributors:
 *  James Worthington - Initial implementation
 *  Amina Rais - Massive Improvements
 *  Version: 2.0.0
 *
 *******************************************************************************/


import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Typography } from '@mui/material';
import { useState } from 'react';
import { useCallback } from 'react';
import { getSplunkHistory } from '../../../../../store/reducers/splunk/splunkAction';
import TimelineHistory from '../../../../../components/ui-elements/timeline/TimelineHistory';

const SplunkHistory = ({ selectedRecordId }) => {
    const [historyList, setHistoryList] = useState([]);
    const dispatch = useDispatch()
    const splunkHistoryList = useSelector(state => state.splunk.splunkHistory)
    const fetchSplunkHistory = useCallback(async () => {
        dispatch(getSplunkHistory({ "recordID": selectedRecordId }));

    }, [dispatch, selectedRecordId]);
    useEffect(() => {
        fetchSplunkHistory()
    }, [fetchSplunkHistory]);
    useEffect(() => {
        setHistoryList([]);
        if (splunkHistoryList?.length > 0) { 
            splunkHistoryList.forEach(element => {
                setHistoryList(item => [...item, {
                    ...element, Record: {
                        name: element.Record.recordDescription ?? "",
                        details: [],
                        createdBy: element.Record.createdBy ?? "",
                        updatedBy: element.Record.updatedBy ?? "",
                    }
                }]);
            });
        }
    }, [splunkHistoryList]); 
    return (
        <>
            <Typography variant="h3" align="center" color="success.light">Splunk  History</Typography>
            <TimelineHistory items={historyList} />
        </>
    )

}


export default SplunkHistory;